export const ANALYTICS_ROOT_KEY = 'actors table';
export const ANALYTICS_ROLE_ADDED = 'added';
export const ANALYTICS_ROLE_REMOVED = 'removed';
